
import '@watergis/maplibre-gl-terradraw/dist/maplibre-gl-terradraw.css'
import { MaplibreTerradrawControl, MaplibreMeasureControl } from '@watergis/maplibre-gl-terradraw';
import { Map, useControl, useMap, Popup } from 'react-map-gl/maplibre';
import { useEffect, useRef, useState } from 'react';
import { sample } from '@turf/turf';
import {
    addDoc,
    getDocs,
    setDoc,
    collection,
    getFirestore,
    onSnapshot,
    doc,
    deleteDoc,
} from "firebase/firestore";
import { db, auth } from '../../firebase/firebase';
import { Row, Col, Form } from 'react-bootstrap';

export const sampleData = [
    {
        "id": "775084a3-eb6a-4aca-8674-46427d874da2",
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [
                121.332886124,
                -30.678422551
            ]
        },
        "properties": {
            "mode": "point"
        }
    },
    {
        "id": "16c380e0-08a0-471d-b147-b38d204bb51a",
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [
                121.326206076,
                -30.686540341
            ]
        },
        "properties": {
            "mode": "point"
        }
    },
    {
        "id": "be0c30db-7d8a-4c64-bbd4-19954071311f",
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [
                121.345520128,
                -30.689162865
            ]
        },
        "properties": {
            "mode": "point"
        }
    },
    {
        "id": "3fdecd27-ee81-4648-9b88-6a8b5ef1d921",
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [
                121.331724376,
                -30.696405658
            ]
        },
        "properties": {
            "mode": "point"
        }
    },
    {
        "id": "0d859268-e881-44fa-b6ca-8727ca9b808e",
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [
                121.339566172,
                -30.696905141
            ]
        },
        "properties": {
            "mode": "point"
        }
    },
    {
        "id": "27024e00-f160-45d0-a34d-6d90027cb9f6",
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [
                121.347698405,
                -30.699402517
            ]
        },
        "properties": {
            "mode": "point"
        }
    }
]

export const arrayToObject = (array, keyField) =>
    array.reduce((obj, item) => {
        obj[item[keyField]] = item
        return obj
    }, {})




export function DrawControl({ drawCtrl, drawpointMode, overlayVisibility }) {


    const loadData = () => {
        const userId = auth.currentUser?.uid;

        const markerStorageLocation = collection(
            db,
            "user_info",
            userId,
            "placemarks"
        );

        const placemarks = getDocs(markerStorageLocation).then(placemarks => {
            const allStoredMarkers = [];
            placemarks.forEach(mark => {
                allStoredMarkers.push(mark.data());
            })
            const drawInstance = drawCtrl.getTerraDrawInstance();
            // Only add features if Terra Draw is enabled
            if (drawInstance && drawInstance.enabled) {
                drawInstance.addFeatures(allStoredMarkers);
            }
        })
    }

    const preciousMetalConfig = {
        id: 'draw-layer-point',
        'source': 'td-point',

        type: 'symbol',
        layout: {
            'icon-image': 'red-marker',
        }
    }


    useEffect(() => {
        if (overlayVisibility.waypoints) {
            drawCtrl.activate();
            // Small delay to ensure Terra Draw is fully activated before loading data
            setTimeout(() => loadData(), 100);

        } else {
            drawCtrl.deactivate();
        }
    }, [overlayVisibility.waypoints])


    useControl(() => drawCtrl, // create
        (e) => {
            // Terra Draw initialization
            // Data loading is handled in the useEffect hook when waypoints overlay is enabled

            e.map.once('load', () => {

            });

        }, // ,add
        (map, lib) => { }, // remove
        {
            position: 'top-left'
        }

    );
    const { goldfindermap } = useMap(); // `mymap` is the id in <Map id="mymap" />





    useEffect(() => {


        drawCtrl.getTerraDrawInstance().on("change", (ids, type) => {
            //Done editing
            const snapshot = drawCtrl.getTerraDrawInstance().getSnapshot();


            const userId = auth.currentUser?.uid;

            if (type === "delete") {
                // delete the points from the store
                ids.forEach(id => {
                    const markerStorageLocation = doc(
                        db,
                        "user_info",
                        userId,
                        "placemarks",
                        id
                    );

                    deleteDoc(markerStorageLocation);
                })

            } else {
                ids.forEach(id => {
                    const markerStorageLocation = doc(
                        db,
                        "user_info",
                        userId,
                        "placemarks",
                        id
                    );

                    const docRef = setDoc(markerStorageLocation,
                        drawCtrl.getTerraDrawInstance().getSnapshotFeature(id)
                    );
                });
            }
        });


        drawCtrl.getTerraDrawInstance().on("finish", (id, context) => {
            if (context.action === 'draw') {
                drawCtrl.getTerraDrawInstance().setMode('select')
                // TODO figure out how to stop this
                //drawCtrl.getTerraDrawInstance().setMode('point');
            } else if (context.action === 'dragFeature') {
                // Do something for a drag finish event
            } else if (context.action === 'dragCoordinate') {
                //
            } else if (context.action === 'dragCoordinateResize') {
                //
            }
        });


    }, [])
}

function DelayedStringInputField({ setValue, value, label }) {
    const [query, setQuery] = useState(value);

    useEffect(() => {
        if (query !== value) {

            const timeOutId = setTimeout(() => setValue(query), 200);
            return () => clearTimeout(timeOutId);
        }
    }, [query]);


    useEffect(() => {
        if (query !== value) {
            setQuery(value);
        }
    }, [value]);

    return (
        <>
            <Form.Label column="sm"  >{label}</Form.Label>
            <Form.Control
                size="sm"
                type="text"
                value={query}
                onChange={event => setQuery(event.target.value)}
            />
        </>
    );
}

function DelayedTextAreaInputField({ setValue, value, label }) {
    const [query, setQuery] = useState(value);

    useEffect(() => {
        if (query !== value) {

            const timeOutId = setTimeout(() => setValue(query), 200);
            return () => clearTimeout(timeOutId);
        }
    }, [query]);


    useEffect(() => {
        if (query !== value) {
            setQuery(value);
        }
    }, [value]);

    return (
        <>
            <Form.Label column="sm"  >{label}</Form.Label>
            <Form.Control
                as="textarea"
                rows={4}
                size="sm"
                type="text"
                value={query}
                onChange={event => setQuery(event.target.value)}
            />
        </>
    );
}

//


export function CreateDrawPointPopup({ feature, latLng, setClosed, drawctrl }) {

    const [name, setName] = useState(feature.properties.name);
    const [desc, setDesc] = useState(feature.properties.description);

    const updateName = (name) => {
        drawctrl.getTerraDrawInstance().removeFeatures([feature.id])
        feature.properties.name = name;
        drawctrl.getTerraDrawInstance().addFeatures([feature])
    }

    const updateDesc = (desc) => {
        drawctrl.getTerraDrawInstance().removeFeatures([feature.id])
        feature.properties.description = desc;
        drawctrl.getTerraDrawInstance().addFeatures([feature])
    }

    const deleteFeat = (id) => {
        drawctrl.getTerraDrawInstance().removeFeatures([id])
        setClosed(false)
    }


    //drawctrl.getTerraDrawInstance().addFeatures([feature])

    return <Popup latitude={latLng.lat} longitude={latLng.lng}
        anchor="bottom"
        onClose={() => setClosed(false)}>
        <Row className='mb-1'>
            <Col>
                <DelayedStringInputField setValue={updateName} value={name} label='Name' />
            </Col>
        </Row>
        <Row className='mb-1'>
            <Col>
                <DelayedTextAreaInputField setValue={updateDesc} value={desc} label='Notes' />
            </Col>
        </Row>
        <Row style={{ fontSize: 'medium' }}>
            <Col>
                lng: {feature.geometry.coordinates[0].toFixed(3)}
                <br />
                lat:  {feature.geometry.coordinates[1].toFixed(3)}
            </Col>
            <Col >
                <button class="btn btn-danger" onClick={() => deleteFeat(feature.id)}>Delete</button>

            </Col>
        </Row>

    </Popup >
}
